import React from 'react';

export const InstagramIcon = (props) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect x="2.5" y="2.5" width="19" height="19" rx="5" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="12" cy="12" r="4.3" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="17.3" cy="6.7" r="1.1" fill="currentColor" />
    </svg>
);

export const LinkedInIcon = (props) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <rect x="2.5" y="2.5" width="19" height="19" rx="3" stroke="currentColor" strokeWidth="1.8" />
        <circle cx="7.2" cy="8" r="1.4" fill="currentColor" />
        <path d="M7.2 11v6.2" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M11.5 17.2V11m0 0c0-1.3 1-2.2 2.3-2.2s2.4.9 2.4 2.5v5.9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

export const TelegramIcon = (props) => (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="12" cy="12" r="9.5" stroke="currentColor" strokeWidth="1.8" />
        <path d="M6.5 12.2l10-4.4-2.3 10.5-3.3-2.6-1.8 1.7-.3-3 6-5.4-7.5 4.6-3.3-1c-.6-.2-.6-.7.2-1z" fill="currentColor" />
    </svg>
);
